export class ObjectPropertyValidator {
    data;
    constructor(data) {
        this.data = data;
    }
    validate(value, data) {
        return this.data.validate(value, data);
    }
}
